<div
  [innerHTML]="svgData"
  [style.height]="height"
  [style.width]="width || '80px'"
  id="svg-viewer"
></div>
